import React from "react";
import { Table } from "react-bootstrap";
import "./style.css";

const StudentConcessionPrint = ({
  reportData,
  getfeeSum,
  getConfeeSum,
  feeTotal,
  grandTotal,
}) => {
  let num2 = 0;

  return (
    <>
      <div id="tableboot">
        <table style={{ width: "100%" }}>
          <thead>
            <tr id="tbl" className="borderIt">
              <td
                style={{
                  color: "black",
                  textAlign: "center",
                }}
              >
                Sr.No
              </td>
              <td
                style={{
                  color: "black",
                  textAlign: "center",
                }}
              >
                Adm-Id
              </td>
              <td
                style={{
                  color: "black",
                  textAlign: "center",
                }}
              >
                Name
              </td>
              <td
                style={{
                  color: "black",
                  textAlign: "center",
                }}
              >
                Father Name
              </td>
              <td
                style={{
                  color: "black",
                  textAlign: "center",
                }}
              >
                Mobile
              </td>
              <td
                style={{
                  color: "black",
                  textAlign: "center",
                }}
              >
                Fee
              </td>
              <td
                style={{
                  color: "black",
                  textAlign: "center",
                }}
              >
                Concession
              </td>
              <td
                style={{
                  color: "black",
                  textAlign: "center",
                }}
              >
                Remarks
              </td>
            </tr>
          </thead>
          <tbody>
            {reportData.length > 0
              ? reportData.map((item, index) => (
                  <React.Fragment key={index}>
                    {item?.courses?.length > 0 && (
                      <tr className="mx-4" style={{ marginTop: "40px" }}>
                        <td colSpan={9} className="text_align_start">
                          <h3 className="text-primary">{item.campus}</h3>
                        </td>
                      </tr>
                    )}
                    {item?.courses?.map((subitem) =>
                      subitem?.classes?.map((subsubitem) =>
                        subsubitem?.sections?.map((session, subindex) => (
                          <React.Fragment key={subindex}>
                            {session.students.length > 0 ? (
                              <React.Fragment>
                                <tr style={{ borderBottom: "1px solid black" }}>
                                  <td colSpan={3} className="text-center">
                                    <h4 className="">
                                      <b>Course:-</b> {subitem?.course?.name}{" "}
                                    </h4>
                                  </td>
                                  <td colSpan={5} className="text-center">
                                    <h4 className="">
                                      <b>Class:-</b> {subsubitem.class?.name}(
                                      {session.section?.name})
                                    </h4>
                                  </td>
                                </tr>
                                <React.Fragment>
                                  {session?.students.map((student, index) => (
                                    <tr
                                      id="tbl"
                                      key={index}
                                      style={{
                                        borderBottom: "1px solid black",
                                      }}
                                    >
                                      <td
                                        style={{ color: "black" }}
                                        className="text-center"
                                      >
                                        {index + 1}
                                      </td>
                                      <td
                                        style={{ color: "black" }}
                                        className="text-center"
                                      >
                                        {student.admission_id}
                                      </td>
                                      <td
                                        style={{ color: "black" }}
                                        className="text_align_start"
                                      >
                                        {student.name}
                                      </td>
                                      <td
                                        style={{ color: "black" }}
                                        className="text_align_start"
                                      >
                                        {student.father_name}
                                      </td>
                                      <td
                                        style={{ color: "black" }}
                                        className="text_align_start"
                                      >
                                        {student?.concession_remarks}
                                      </td>
                                      <td
                                        style={{ color: "black" }}
                                        className="text-center"
                                      >
                                        {student.mobile_no}
                                      </td>
                                      <td
                                        style={{ color: "black" }}
                                        className="text-center"
                                      >
                                        {student.employee_id}
                                      </td>

                                      <td
                                        style={{ color: "black" }}
                                        className="text-center"
                                      >
                                        {
                                          student?.student_liable_fees[0]
                                            ?.amount
                                        }
                                      </td>
                                      <td
                                        style={{ color: "black" }}
                                        className="text-center"
                                      >
                                        {
                                          student.student_liable_fees[0]
                                            ?.concession
                                        }
                                      </td>
                                    </tr>
                                  ))}
                                </React.Fragment>
                              </React.Fragment>
                            ) : null}
                          </React.Fragment>
                        ))
                      )
                    )}
                    {item?.courses?.length > 0 && (
                      <tr id="tbl" style={{ borderBottom: "1px solid black" }}>
                        <td
                          style={{ color: "black" }}
                          className="text_align_start"
                        ></td>
                        <td
                          style={{ color: "black" }}
                          className="text_align_start"
                        ></td>
                        <td
                          style={{ color: "black" }}
                          className="text_align_start"
                        ></td>
                        <td
                          style={{ color: "black" }}
                          className="text_align_start"
                        ></td>
                        <td
                          style={{ color: "black" }}
                          className="text_align_start"
                        ></td>
                        <td
                          style={{ fontSize: "1.3rem" }}
                          colSpan={2}
                          className="text_align_start text-primary"
                        >
                          Total
                        </td>
                        <td
                          style={{ color: "black", fontSize: "1.3rem" }}
                          className="text-center"
                        >
                          {getfeeSum(item)}
                        </td>
                        <td
                          style={{ color: "black", fontSize: "1.3rem" }}
                          className="text-center"
                        >
                          {getConfeeSum(item)}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              : null}

            <tr id="tbl" className="borderIt">
              <td style={{ color: "black" }} className="text_align_start"></td>
              <td style={{ color: "black" }} className="text_align_start"></td>
              <td style={{ color: "black" }} className="text_align_start"></td>
              <td style={{ color: "black" }} className="text_align_start"></td>
              <td style={{ color: "black" }} className="text_align_start"></td>
              <td style={{ color: "black" }} className="text_align_start"></td>
              <td
                style={{ fontSize: "1.5rem" }}
                className="text-center text-primary"
              >
                Grand Total
              </td>
              <td
                style={{ color: "black", fontSize: "1.5rem" }}
                className="text-center"
              >
                {feeTotal}
                {/* {getfeeSum(item)} */}
              </td>
              <td
                style={{ color: "black", fontSize: "1.5rem" }}
                className="text-center"
              >
                {grandTotal}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default StudentConcessionPrint;
